module.exports = __webpack_public_path__ + "static/media/rabbit.cc6706c5.png";